module.exports = __webpack_public_path__ + "media/components/questionnaire-banner/static/icon-close-bc52812e92e225c553f79ce856ea853d.svg";